import { useEffect, useState } from "react";

type CommonProps = {
    value?: string | object;
    _label?: string;
    inputType: "string" | "object";
    rows?: number;
};

type PropsString = CommonProps & {
    returnType: "string";
    onChange: (v: string) => void;
};

type PropsObject = CommonProps & {
    returnType: "object";
    onChange: (v: Record<string, any>) => void;
};

type Props = PropsString | PropsObject;

export const JsonFormaterInput = ({
    onChange,
    returnType,
    value,
    _label,
    inputType,
    rows
}: Props) => {
    const [inputValue, setInputValue] = useState<string>("{}");
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (value == null) {
            setInputValue(inputType === "object" ? "{}" : "");
            setError(null);
            return;
        }

        try {
            if (inputType === "object") {
                if (typeof value === "string") {
                    const parsed = JSON.parse(value);
                    setInputValue(JSON.stringify(parsed, null, 2));
                } else if (Array.isArray(value)) {
                    setInputValue(JSON.stringify(value, null, 2));
                } else if (typeof value === "object") {
                    setInputValue(JSON.stringify(value, null, 2));
                }
            } else {
                if (typeof value === "string") {
                    setInputValue(value);
                } else {
                    setInputValue(JSON.stringify(value, null, 2));
                }
            }
            setError(null);
        } catch {
            setInputValue(typeof value === "string" ? value : String(value));
            setError("El valor no se pudo formatear como JSON.");
        }
    }, [value, inputType]);

    const handleBlur = () => {
        try {
            const parsed = JSON.parse(inputValue);
            const formatted = JSON.stringify(parsed, null, 2);
            setInputValue(formatted);
            setError(null);

            if (returnType === "string") {
                onChange(formatted);
            } else {
                onChange(parsed);
            }
        } catch {
            setError("El JSON ingresado no es válido.");
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setInputValue(e.target.value);
        setError(null);
    };

    return (
        <div className="col-md-12">
            <label className="form-label">{_label ?? "Json Input"}</label>
            <textarea
                rows={rows ?? 5}
                value={inputValue}
                className="form-control"
                onChange={handleChange}
                onBlur={handleBlur}
            />
            {error && <div className="text-danger mt-1">{error}</div>}
        </div>
    );
};
